import { Link, useNavigate } from 'react-router-dom';
import { useSeo } from '@/seo/useSeo';
import { seoNoIndexar } from '@/seo/datos';

const QUICK_LINKS = [
  { icon: 'ri-home-line',          label: 'Inicio',    href: '/' },
  { icon: 'ri-store-2-line',       label: 'Productos', href: '/products' },
  { icon: 'ri-customer-service-2-line', label: 'Contacto', href: '/contact' },
  { icon: 'ri-information-line',   label: 'Nosotros',  href: '/about' },
];

export default function NotFound() {
  useSeo(seoNoIndexar('Página no encontrada', window.location.pathname));
  const navigate = useNavigate();

  return (
    <main className="min-h-screen bg-white flex flex-col items-center justify-center px-4 py-20">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-primary-50 opacity-40 blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full bg-secondary-50 opacity-30 blur-3xl" />
      </div>

      <div className="relative z-10 text-center max-w-lg">
        {/* 404 number */}
        <div className="relative mb-6">
          <span className="font-display font-black text-[10rem] leading-none text-neutral-50 select-none">
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-primary-600 to-secondary-500 rounded-2xl">
              <i className="ri-compass-discover-line text-white text-4xl" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="font-display font-bold text-2xl md:text-3xl text-content-primary mb-3">
          Página no encontrada
        </h1>
        <p className="text-content-secondary text-sm md:text-base leading-relaxed mb-8">
          La página que buscas no existe o ha sido movida. Prueba con uno de estos enlaces o vuelve al inicio.
        </p>

        {/* Quick links */}
        <div className="grid grid-cols-2 gap-3 mb-8">
          {QUICK_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="flex items-center gap-2.5 px-4 py-3 bg-neutral-50 hover:bg-primary-50 border border-neutral-100 hover:border-primary-200 rounded-xl text-sm font-medium text-content-secondary hover:text-primary-700 transition-all duration-200 cursor-pointer"
            >
              <i className={`${link.icon} text-primary-500 text-base`} />
              {link.label}
            </Link>
          ))}
        </div>

        {/* Primary CTA */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 border border-neutral-200 hover:border-primary-300 text-content-secondary hover:text-primary-600 text-sm font-semibold px-6 py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            Volver atrás
          </button>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white text-sm font-semibold px-6 py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            style={{ boxShadow: '0 4px 14px rgb(26 58 107 / 0.25)' }}
          >
            <i className="ri-home-line" />
            Ir al inicio
          </Link>
        </div>
      </div>
    </main>
  );
}
